import { useQueryClient } from "@tanstack/react-query";
import { attendanceService } from "../../../api/attendanceService";
import { useToast } from "../../../components/ui/useToast";
import { getErrorMessage } from "../../../utils/apiError";
import { cx } from "../../../utils/classNames";
import ui from "../../../components/ui/ui.module.css";

// "View check-in location" / "View check-out location" for a month-summary
// day. The summary has no coordinates, so the day's locations are fetched on
// click and Google Maps opens in a new tab (first check-in, last check-out).
//   kind: "in" | "out"
const DayMapLink = ({ record, kind }) => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const time = kind === "in" ? record?.checkInTime : record?.checkOutTime;
  if (!record?.id || !record.hasLocation || !time) return null;

  const label =
    kind === "in" ? "View check-in location" : "View check-out location";

  const open = async () => {
    // Open the tab now (inside the click) so pop-up blockers allow it.
    const tab = window.open("about:blank", "_blank");
    if (tab) tab.opener = null;

    try {
      const data = await queryClient.fetchQuery({
        queryKey: ["me:attendance", "locations", record.id],
        queryFn: () => attendanceService.getLocations(record.id),
        staleTime: 5 * 60 * 1000,
      });
      const sessions = data.sessions ?? [];
      const url =
        kind === "in"
          ? sessions.find((s) => s.checkIn?.mapUrl)?.checkIn.mapUrl
          : [...sessions].reverse().find((s) => s.checkOut?.mapUrl)?.checkOut
              .mapUrl;

      if (!url) {
        tab?.close();
        toast.error(
          `No ${kind === "in" ? "check-in" : "check-out"} location was recorded for this day.`,
        );
        return;
      }
      if (tab) tab.location.href = url;
      else window.open(url, "_blank", "noopener");
    } catch (error) {
      tab?.close();
      toast.error(getErrorMessage(error, "Unable to load the location."));
    }
  };

  return (
    <button
      type="button"
      className={cx(ui.linkButton, "d-block small")}
      onClick={open}
    >
      <i className="bi bi-geo-alt me-1"></i>
      {label}
    </button>
  );
};

export default DayMapLink;
